import { wallets } from './wallets';
export const getInjectedAddress = (wallet) => {
    var _a;
    switch (wallet === null || wallet === void 0 ? void 0 : wallet.name) {
        case wallets.metamask.name:
            return getMetamaskInjectedAddress();
        case wallets.tallyho.name:
            return getTallyInjectedAddress();
        default:
            return (_a = getMetamaskInjectedAddress()) !== null && _a !== void 0 ? _a : getTallyInjectedAddress();
    }
};
const getMetamaskInjectedAddress = () => {
    var _a;
    return (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.selectedAddress;
};
const getTallyInjectedAddress = () => {
    var _a;
    return (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.selectedAddress;
};
